import { File } from '../file';

/**
 * Model definition for GirokontoBenefits
 */
export interface GirokontoBenefits {
  __component: 'girokonto.benefits';
  id: string;
  headlineTitle?: string;
  media?: File;
}

export function isGirokontoBenefits(obj: { __component?: string }): obj is GirokontoBenefits {
  return obj.__component === 'girokonto.benefits';
}
